import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
import styles from './AvatarGroup.styles.scss';
const template = html `<slot></slot>`;
export const avatarGroupDefinition = {
    name: 'chameleon-avatar-group',
    template,
    styles,
};
const NUMBER_OF_COLORS = 18;
let AvatarGroupComponent = class AvatarGroupComponent extends ChameleonElementMixin(FASTElement) {
    constructor() {
        super(...arguments);
        this.max = 3;
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        this.render();
    }
    getAvatars() {
        return this.querySelectorAll('chameleon-avatar');
    }
    render() {
        var _a, _b;
        const max = this.hasAttribute('max') ? +((_a = this.getAttribute('max')) !== null && _a !== void 0 ? _a : '3') : this.max;
        const avatars = this.getAvatars();
        const avatarColorNumbers = [
            '00',
            '01',
            '02',
            '10',
            '11',
            '12',
            '20',
            '21',
            '22',
            '30',
            '31',
            '32',
            '40',
            '41',
            '42',
            '50',
            '51',
            '52',
        ];
        let avatarIndex = 0;
        avatars.forEach((avatar) => {
            if (avatarIndex >= NUMBER_OF_COLORS)
                avatarIndex = avatarIndex % NUMBER_OF_COLORS;
            avatar.primaryBackgroundColor = `--goto-avatar-bg-color: var(--goto-avatar-color-${avatarColorNumbers[avatarIndex]})`;
            avatarIndex++;
        });
        if ((avatars === null || avatars === void 0 ? void 0 : avatars.length) > max) {
            avatars.forEach((item) => (item.hidden = false));
            avatars.forEach((item) => {
                if (item.hasAttribute('hint')) {
                    item.remove();
                }
            });
            const diff = ((_b = this.getAvatars()) === null || _b === void 0 ? void 0 : _b.length) - max;
            const itemsToRemove = [...avatars].slice(max);
            itemsToRemove.forEach((item) => (item.hidden = true));
            if (diff > 0) {
                const avatar = document.createElement('chameleon-avatar');
                avatar.setAttribute('hint', '');
                avatar.textContent = `+${diff}`;
                this.appendChild(avatar);
            }
        }
    }
};
__decorate([
    attr
], AvatarGroupComponent.prototype, "max", void 0);
AvatarGroupComponent = __decorate([
    customElement(avatarGroupDefinition)
], AvatarGroupComponent);
export { AvatarGroupComponent };
